(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sarasin-journey-timeline"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.sarasin-jrn [data-reveal]').forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarasin-nonnegotiables-tiles"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.sarasin-nn [data-reveal]').forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarasin-page-longevity"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.sarasin-sci [data-reveal]').forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarasin-page-science"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.sarasin-scipg [data-reveal]').forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sarasin-page-story"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.sarasin-story [data-reveal]').forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
